import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { ListSegClassicTimestampTypes } from './ListSegConstants';
export const getListSegClassicTimestampType = ({
  type
}) => {
  if (type === PropertyTypes.DATE) {
    return ListSegClassicTimestampTypes.UTC_TZ_ALIGNED;
  }
  return ListSegClassicTimestampTypes.PORTAL_TZ_ALIGNED;
};